'use client';
import { createContext, useContext } from 'react';

import { School } from 'model/misc';

export interface ISchoolContext {
  // schoolId is the currently selected school. it will never be null\undefined
  schoolId: string;
  // school is the school object for the currently selected school. it will never be null\undefined
  school: School;
  // availableSchools a collection of all available schools.
  availableSchools: School[];
  // setSchoolId allows to set the current school.
  // only one of the schools from the availableSchools can be picked.
  // if the school that is not in the list is selected, it will fall back to the first school in the list.
  setSchoolId: (schoolID: string) => Promise<void>;
}

export const EMPTY_SCHOOL: School = { id: '', name: '' };

export const SchoolContext = createContext<ISchoolContext>({} as ISchoolContext);

export const useSchoolContext = () => useContext(SchoolContext);
